/* eslint-disable */

// Set this to true to log all http calls to console, including the duration taken to perform it.
const REQUEST_LOGGING = false;

// Set this to true to log all http responses to console. Beware that this may significantly slow down the app.
const RESPONSE_LOGGING = false;

export const urlencode = (obj) => {
    let result = [];

    for (let property of Object.keys(obj)) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(obj[property]);
        result.push(`${encodedKey}=${encodedValue}`);
    }

    return result.join('&');
};

export const request = async (method, url, payload=null, accessToken) => {
    // Register start time and log url
    let startTime;
    if (REQUEST_LOGGING) {
        startTime = new Date().getTime();
        console.log(`%cSession: ${method} ${url}`, 'font-weight: bold;');
    }

    let headers = {
        'Accept': 'application/json',
    };
    if (payload && !payload.formData){
        headers['Content-Type'] = 'application/json';
    }

    if (accessToken) {
        headers = {
            ...headers,
            'Authorization': `Bearer ${accessToken}`
        };
    }

    let body;
    if (payload) {
        if (payload.formData){
            body = payload.formData;
        }else {
            body = JSON.stringify(payload);
        }
    }

    // Perform fetch
    let response = await fetch(url, {
        method: method,
        headers,
        body
    });

    // Register parsing start time
    let parseStartTime;
    if (REQUEST_LOGGING) {
        parseStartTime = new Date().getTime();
        console.log(`URL: ${url}`);
        console.log(`Headers: ${JSON.stringify(headers)}`);
        console.log(`Payload: ${JSON.stringify(payload)}`);
        console.log(`Body: ${body}`);
    }

    // Throw if we get an error response
    if (!response.ok) {
        throw { status: response.status, message: await response.text() };
    }

    let data;

    try {
        if (url.indexOf('image/get_by_key/') > -1) { // i'm sorry  :-(
            return response.url;
        }
        let responseText = await response.text();
        let json;

        if (responseText) {
            json = JSON.parse(responseText);
        }

        // Log request duration
        if (REQUEST_LOGGING) {
            let endTime = new Date().getTime();
            console.log(`REQUEST TIME: ${parseStartTime - startTime} ms, parsing: ${endTime - parseStartTime} ms`);
            console.log(`Payload: ${JSON.stringify(payload)}`);
        }

        // Log response
        if (RESPONSE_LOGGING) {
            console.log(json);
        }
        data = json;
    } catch (error) { // no json?
        console.warn(error);
    }

    return data;
};
